import { BoxProps } from "@mui/material"
import React from "react"

import { Box, Checkbox, TextField, Typography } from "src/UILibrary"
import { SelectDataType } from "./SelectDataType"

type Props = {
  sx?: BoxProps
  name?: string
  nameSize?: number
  required?: boolean
  datas: SelectDataType[]
  labelSize?: number
  lineSpace?: number
  radio?: boolean
  selected: any[] | any | undefined
  handleSelected: any
  validationMessage?: string
  hasText?: boolean
  text?: string
  handleText?: any
  multiline?: boolean
  disabled?: boolean
  alignHorizontal?: boolean
  labelStyle?: any
  description?: string
  descriptionStyle?: any
  lineBreak?: boolean
  noValidation?: boolean
}

const CheckBoxGroupField = ({
  sx,
  name,
  nameSize,
  required,
  datas,
  labelSize,
  lineSpace,
  radio,
  selected,
  handleSelected,
  validationMessage,
  hasText,
  text,
  handleText,
  multiline,
  disabled,
  alignHorizontal,
  labelStyle,
  description,
  descriptionStyle,
  lineBreak,
  noValidation,
}: Props) => {
  let style = sx || {}

  style = alignHorizontal
    ? { ...style, display: "flex", flexDirection: "row", flexWrap: "wrap" }
    : { ...style, display: "flex", flexDirection: "column" }

  const customStyle = {
    "& .MuiFormControlLabel-label": labelSize
      ? {
          fontSize: labelSize,
        }
      : {},
  }

  const handleChange = (index: number, checked: boolean) => {
    if (radio) {
      if (checked) {
        handleSelected(datas[index].value)
      } else {
        handleSelected(undefined)
      }
    } else {
      if (checked) {
        handleSelected([...selected, datas[index].value])
      } else {
        const indexToRemove = selected.indexOf(datas[index].value)
        if (indexToRemove < 0) {
          return
        }
        let tmpSelected = [...selected]
        tmpSelected.splice(indexToRemove, 1)
        handleSelected(tmpSelected)
      }
    }
  }

  return (
    <>
      {lineBreak ? (
        <>
          <Box sx={{ mt: "10px" }}>
            {name && (
              <Typography.SubHeadNormal
                sx={{ mr: "6px", ...(nameSize ? { fontSize: nameSize } : {}), ...labelStyle }}
              >
                {name}
              </Typography.SubHeadNormal>
            )}
            {name && required && (
              <Box
                sx={{
                  px: "8px",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderRadius: "4px",
                  borderColor: "text.border",
                }}
              >
                <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
                  必須
                </Typography.InputFieldRequired>
              </Box>
            )}
          </Box>
        </>
      ) : (
        <></>
      )}
      <Box
        sx={{
          ...style,
          ...customStyle,
        }}
      >
        <Box
          display="flex"
          sx={alignHorizontal ? { my: lineBreak ? "0px" : "auto" } : { mb: "8px" }}
        >
          {lineBreak ? (
            <></>
          ) : (
            <>
              {name && (
                <Typography.SubHeadNormal
                  sx={{ mr: "6px", ...(nameSize ? { fontSize: nameSize } : {}), ...labelStyle }}
                >
                  {name}
                </Typography.SubHeadNormal>
              )}
              {name && required && (
                <Box
                  sx={{
                    px: "8px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderRadius: "4px",
                    borderColor: "text.border",
                  }}
                >
                  <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
                    必須
                  </Typography.InputFieldRequired>
                </Box>
              )}
            </>
          )}
        </Box>
        {description && (
          <Typography.SubHeadNormal sx={{ ...descriptionStyle }}>
            {description}
          </Typography.SubHeadNormal>
        )}
        {radio
          ? datas.map((data, index) => {
              return (
                <Checkbox
                  key={index}
                  label={data.label}
                  onChange={(evnet, checked) => handleChange(index, checked)}
                  checked={selected === data.value}
                  sx={{ ...(lineSpace ? { py: lineSpace } : {}) }}
                  disabled={disabled}
                />
              )
            })
          : datas.map((data, index) => {
              return (
                <Checkbox
                  key={index}
                  label={data.label}
                  checked={selected.includes(data.value)}
                  onChange={(event, checked) => handleChange(index, checked)}
                  sx={{ ...(lineSpace ? { py: lineSpace } : {}) }}
                  disabled={disabled}
                />
              )
            })}
      </Box>
      {hasText && radio && selected !== undefined && datas[selected - 1]?.label === "その他" && (
        <TextField
          variant="standard"
          sx={{
            width: "100%",
            fontFamily: "Noto Sans JP !important",
            ...style,
            mt: 0,
          }}
          multiline={multiline}
          minRows={multiline ? 4 : 1}
          disabled={disabled}
          value={text}
          onChange={(event) => handleText!(event.target.value)}
        />
      )}

      {noValidation ? (
        <></>
      ) : (
        <>
          {validationMessage && (
            <Box sx={{ height: "20px", pt: "5px" }}>
              <Typography.ValidationText>{validationMessage}</Typography.ValidationText>
            </Box>
          )}
        </>
      )}
    </>
  )
}

export default CheckBoxGroupField
